import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label
} from "reactstrap"
import Shimmer from "react-shimmer-effect";
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { YearSelect, MonthSelect } from '../../../../helpers/ui/YearSelect'
import { accessRole } from '../../../../helpers/access_role'
import { Preview, generateFormData } from '../../../../helpers/ui/FileInput'
import Select from '../../../../helpers/ui/CustomSelect'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'

import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'
import UpdateBloc from './Blocs/UpdateBloc'
import moment from 'moment';

class UpdateView extends Component {

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")
    peg_nip = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_nip : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_nip : "")

    updateBloc = new UpdateBloc();
    
    source
    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            rankOption: [],
            signatoriesOption: [],
            detail: [],
            rankFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'rank_id',
                    order: 'asc' 
                }
            },
            signatoriesFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'signatories_official_id',
                    order: 'asc' 
                }               
            }, 
            decree_cpns_signatories_official_name: '',
            decree_cpns_signatories_official_nip: '',
            decree_cpns_adjustment_signatories_official_name: '',
            decree_cpns_adjustment_signatories_official_nip: '',
            optionStatusApproval : [
                { label: "Disetujui", value: 1 },
                { label: "Ditolak", value: 2 }
            ],
        }
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                decree_pns_uuid: this.props.id,
                employee_nip: this.peg_nip,
                decree_pns_employee_uuid: this.peg_uuid,
                ...values
            },
            confirm: true
        })
    }

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, 'document')
        await this.updateBloc.fetchApprove(formData)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    loadDetail = async () => {
        const query = {
            uuid: this.props.id,
            history: 1
        }
        await this.updateBloc.fetchDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadDetail()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.updateBloc.detailChannel.subscribe((result) => {
            let response_current = result.data.response.current
            let response_history = result.data.response.history
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        detail: response_current,
                        history: response_history
                    })
                    break;
                default:
                    break;
            }
        })

        this.updateBloc.approveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        const queryParams = new URLSearchParams(window.location.search)

        /* 
            If Administrator
            Set Employee Selected on localstorage by Notification Click 
        */
        try {
            let causer = queryParams.get('causer')

            if (causer != null){
                let arrCauser = atob(causer).split('|');
    
                let dataUser = {
                    employee_uuid: arrCauser[1],
                    employee_name : arrCauser[0],
                    employee_current_position_name : arrCauser[2],
                    employee_nip : arrCauser[3]
                }
                localStorage.setItem('employeeSelected', JSON.stringify(dataUser))
                //console.log(arrCauser);
            }
        } catch (error) {}

    }

    componentWillUnmount() {
        this.updateBloc.detailChannel?.unsubscribe()
        this.updateBloc.approveChannel?.unsubscribe()
    }


    render() {
        const { detail } = this.state
        const { result, total } = this.state.rankOption
        const signatoriesResult = this.state.signatoriesOption?.result
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="skpns" />

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Approve SK PNS</CardTitle>
                                    {/* <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle> */}
                                    <hr />          
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        {
                                            this.state.history ?
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    
                                                </label>
                                                <Col md="5">
                                                    <strong> Data Baru </strong>
                                                </Col>
                                                <Col md="4">
                                                    <strong className="text-danger"> Data Lama </strong>
                                                </Col>
                                            </Row>
                                        : '' }

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                            Nama Pejabat Penetap    
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.decree_pns_signatories_official_name !== "" ? this.state.detail.decree_pns_signatories_official_name : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.decree_pns_signatories_official_name !== "" ? this.state.history.decree_pns_signatories_official_name : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                            NIP Pejabat Penetap
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.decree_pns_signatories_official_nip !== "" ? this.state.detail.decree_pns_signatories_official_nip : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.decree_pns_signatories_official_nip !== "" ? this.state.history.decree_pns_signatories_official_nip : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                            No Surat Keputusan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.decree_pns_decree_number !== "" ? this.state.detail.decree_pns_decree_number : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.decree_pns_decree_number !== "" ? this.state.history.decree_pns_decree_number : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                            Tanggal Surat Keputusan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.decree_pns_decree_date !== "" ? this.dateParse(this.state.detail.decree_pns_decree_date) : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.decree_pns_decree_date !== "" ? this.dateParse(this.state.history.decree_pns_decree_date) : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                            Terhitung Mulai Tanggal 
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.decree_pns_decree_tmt !== "" ? this.dateParse(this.state.detail.decree_pns_decree_tmt) : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.decree_pns_decree_tmt !== "" ? this.dateParse(this.state.history.decree_pns_decree_tmt) : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                            No Diklat Prajabatan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.decree_pns_training_number !== "" ? this.state.detail.decree_pns_training_number : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.decree_pns_training_number !== "" ? this.state.history.decree_pns_training_number : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                            Tanggal Diklat Prajabatan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.decree_pns_training_date !== "" ? this.dateParse(this.state.detail.decree_pns_training_date) : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.decree_pns_training_date !== "" ? this.dateParse(this.state.history.decree_pns_training_date) : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                            No Surat Uji Kesehatan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.decree_pns_health_test_number !== "" ? this.state.detail.decree_pns_health_test_number : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.decree_pns_health_test_number !== "" ? this.state.history.decree_pns_health_test_number : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                            Tanggal Surat Uji Kesehatan
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.decree_pns_health_test_date !== "" ? this.dateParse(this.state.detail.decree_pns_health_test_date) : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.decree_pns_health_test_date !== "" ? this.dateParse(this.state.history.decree_pns_health_test_date) : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                            Golongan Ruang
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.rank_name !== "" ? this.state.detail.rank_name : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.rank_name !== "" ? this.state.history.rank_name : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                            Dokumen
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.document?.documents_path !== "" ? 
                                                        <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.detail.document?.documents_path}>
                                                            <i className="uil-file-download"></i> Download File
                                                        </a>
                                                        : 'Tidak ada dokumen'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.document?.documents_path !== "" ? 
                                                        <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.history.document?.documents_path}>
                                                            <i className="uil-file-download"></i> Download File
                                                        </a>
                                                        : 'Tidak ada dokumen'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>

                                        <hr />

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Status Approval <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <Select 
                                                    name="status_approval"
                                                    errorMessage="Pilih Status Approval"
                                                    options={this.state.optionStatusApproval} 
                                                    placeholder="Pilih Status Approval"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="status_approval_description"
                                                className="col-md-3 col-form-label"
                                            >
                                            Keterangan Approval <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="status_approval_description"
                                                    placeholder="Keterangan Approval..."
                                                    type="textarea"
                                                    errorMessage="Masukkan Keterangan Approval"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="status_approval_description"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to={`/kepegawaian/home.html?skpns`}>
                                                    <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>

                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={`/kepegawaian/home.html?skpns`} />
                : null }



            </Fragment>
        )
    }
}

export default UpdateView;
